// src/utils/oauthState.js
// R0b (2026-10-16): the one-time OAuth state, bound to this browser, so a
// Discord/Twitch callback is only exchanged when this browser started it
// (login CSRF guard). A short cookie on the parent domain, keyed by the state,
// so a sign-in started on www.critcash.com still matches when the provider
// returns to critcash.com, and two tabs never overwrite each other. The server
// mints the state as 16 random bytes in hex (getDiscordAuthUrl/getTwitchAuthUrl).

const STATE_RE = /^[a-f0-9]{32}$/;
const cookieName = (state) => `cc_oauth_${state}`;

function attrs() {
  if (typeof location === 'undefined') return '; Path=/; SameSite=Lax';
  const domain = /(^|\.)critcash\.com$/.test(location.hostname) ? '; Domain=critcash.com' : '';
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  return `; Path=/; SameSite=Lax${secure}${domain}`;
}

/** Remember a state this browser is about to send to the provider (30 minutes, room to create a Discord/Twitch account mid-flow). */
export function saveOAuthState(state) {
  if (!STATE_RE.test(state || '')) return;
  try {
    document.cookie = `${cookieName(state)}=1; Max-Age=1800${attrs()}`;
  } catch (_) { /* storage blocked: the callback will refuse */ }
}

/** True once if this browser started a sign-in with this state; always clears it. */
export function takeOAuthState(state) {
  if (!STATE_RE.test(state || '')) return false;
  let ok = false;
  try {
    ok = document.cookie.split('; ').includes(`${cookieName(state)}=1`);
    document.cookie = `${cookieName(state)}=; Max-Age=0${attrs()}`;
  } catch (_) { ok = false; }
  return ok;
}
